module.exports = __webpack_public_path__ + "zespol_04.jpg?c6da854a8ae067c39ea56fda2744a65a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zespol_04.jpg
// module id = 149
// module chunks = 0